import React, { Component } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";

import SupportingDocument from "@safecv/common/Components/MultiUpload/SupportingDocument";

import API_CONFIG from "@safecv/src/api-config";

import "./DropDownBar.css";

const customStyles = {
  control: (styles) => ({
    ...styles,
    background: "#e2e8f0",
    pointerEvents: "none",
  }),
};

class StateDropDownBar extends Component {
  render() {
    const {
      statelist,
      jurisdictions,
      planTypes,
      selectedEffectiveFrom,
      selectedDueDate,
      selectedjurisdiction,
      openModal,
      codebooks,
      planTypeId,
      selectedPlanType,
      codebookId,
      selectedCodebook,
      setUploadedAddDocs,
      planName,
      onChangeHandler,
    } = this.props;

    const stateListDisplay = statelist.map((item) => {
      return {
        value: item.id,
        label: item.stateName,
      };
    });
    const displaySelectedJurisdiction = jurisdictions.map((item) => {
      return {
        value: item.id,
        label: item.jurisdictionName,
      };
    });

    const displayPlanTypes = planTypes.map((item) => {
      return {
        value: item.id,
        label: item.planType,
      };
    });

    const displayCodebooks = codebooks.map((item) => {
      return {
        value: item.id,
        label: item.codebookName,
      };
    });

    const selectedValue = selectedjurisdiction
      ? displaySelectedJurisdiction.find(
          (item) => item.label === selectedjurisdiction
        )
      : null;

    return (
      <React.Fragment>
        <div className="zero-padding common-padding right-padding col-sm-6">
          <label className="dd-font-styling">
            State <span className="requiredField">*</span>
          </label>
          <Select
            placeholder="Select State"
            options={stateListDisplay}
            onChange={this.props.handleStateListChange}
          />
        </div>

        <div className="zero-padding r-padding col-sm-6">
          <label className="dd-font-styling">
            Jurisdiction <span className="requiredField">*</span>
          </label>
          <Select
            value={selectedValue === undefined ? null : selectedValue}
            placeholder="Select Jurisdiction"
            options={displaySelectedJurisdiction}
            onChange={(selectedOption) => {
              //clear the display value
              this.props.handleJurisdictionListChange(selectedOption);
            }}
          />
        </div>

        <div className="zero-padding common-padding right-padding col-sm-6">
          <label className="dd-font-styling">
            Plan Type <span className="requiredField">*</span>
          </label>

          {/* Auto populate plantype with the first value */}
          <Select
            value={
              selectedPlanType && planTypeId
                ? { label: selectedPlanType, value: planTypeId }
                : null
            }
            placeholder="Select Plan Type"
            options={displayPlanTypes}
            onChange={(selectedOption) => {
              this.props.handlePlanTypeListChange(selectedOption);
            }}
          />
        </div>
        {API_CONFIG.FEATURE_ADMIN_MULTIVERSION_CODEBOOK_ENABLED && (
          <>
            <div className="zero-padding r-padding col-sm-6">
              <label className="dd-font-styling">
                Submit Date <span className="requiredField">*</span>
              </label>
              <div className="calendar-effective-from">
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    inputVariant="outlined"
                    disableToolbar
                    variant="inline"
                    format="MM/dd/yyyy"
                    value={selectedEffectiveFrom}
                    onChange={(val) =>
                      this.props.handleEffectiveFromChange(val)
                    }
                    inputProps={{
                      style: {
                        padding: "10px 14px",
                      },
                    }}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                  />
                </MuiPickersUtilsProvider>
              </div>
            </div>

            <div className="zero-padding common-padding right-padding col-sm-6">
              <label className="dd-font-styling">
                Due Date <span className="requiredField">*</span>
              </label>
              <div className="calendar-effective-from">
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    inputVariant="outlined"
                    disableToolbar
                    variant="inline"
                    format="MM/dd/yyyy"
                    value={selectedDueDate}
                    onChange={(val) => this.props.handleDueDateChange(val)}
                    inputProps={{
                      style: {
                        padding: "10px 14px",
                      },
                    }}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                  />
                </MuiPickersUtilsProvider>
              </div>
            </div>
            <div className="zero-padding r-padding col-sm-6">
              <label className="dd-font-styling">
                Select Codebook
                {(!selectedPlanType ||
                  (selectedPlanType &&
                    selectedPlanType.toLowerCase() !== "commercial")) && (
                  <span className="requiredField">*</span>
                )}
              </label>

              {/* Auto populate codebook with the first value */}

              <Select
                value={
                  codebookId && selectedCodebook
                    ? {
                        value: codebookId,
                        label: selectedCodebook,
                      }
                    : null
                }
                placeholder="Select Codebook"
                options={displayCodebooks}
                onChange={(selectedOption) => {
                  //set the display value
                  this.props.handleCodebookListChange(selectedOption);
                }}
                styles={
                  selectedPlanType &&
                  selectedPlanType.toLowerCase() === "commercial"
                    ? customStyles
                    : ""
                }
              />
            </div>
          </>
        )}

        <div className="zero-padding common-padding right-padding  col-sm-6 margin-bottom">
          <label className="uploadfile">
            File <span className="requiredField">*</span>
          </label>
          <div style={{ display: "flex" }}>
            <input
              className="inputbox"
              id="fileUpload-true"
              placeholder="Only PDF files."
              disabled
            />
            <button className="upload-btn" style = {{ width: '16%' }} onClick={() => openModal(true)}>
              upload
            </button>
          </div>
        </div>
        <div className="zero-padding r-padding col-sm-6 margin-bottom">
          <label className="uploadplan">
            Plan Name <span className="requiredField">*</span>
          </label>
          <input
            className="plan-name"
            type="text"
            maxLength={100}
            placeholder="Name of the Plan"
            name="planName"
            value={planName}
            onChange={onChangeHandler}
          />
        </div>

        {API_CONFIG.FEATURE_SHARE_VISIBILITY_ENABLED && (
          <div
            className={
              API_CONFIG.FEATURE_ADMIN_MULTIVERSION_CODEBOOK_ENABLED
                ? "zero-padding common-padding common-padding col-sm-6 sharing-checkbox"
                : "zero-padding r-padding col-sm-6 sharing-checkbox margin-top"
            }
          >
            <label style={{ fontSize: "15px" }}>
              Share with everyone
              <input
                type="checkbox"
                checked={this.props.share_isChecked}
                onChange={this.props.shareCheckBoxToggle}
              />
              <span className="share_checkbox" />
            </label>
          </div>
        )}

        {API_CONFIG.FEATURE_GT_UPLOAD_ENABLED && (
          <>
            <hr className="zero-padding form-line" />
            <div className="zero-padding common-padding right-padding col-sm-6 bottom-padding">
              <label className="uploadfile">Ground Truth</label>
              <div style={{ display: "flex" }}>
                <input
                  className="inputbox"
                  id="fileUpload-false"
                  placeholder="Only PDF files."
                  disabled
                />
                <button
                  className="upload-btn"
                  onClick={() => openModal(false)}
                >
                  upload
                </button>
              </div>
            </div>
          </>
        )}

        <div className="supporting-doc-container-width">
          <SupportingDocument setUploadedAddDocs={setUploadedAddDocs} />
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => ({
  jurisdictions: state.criteria.jurisdictions,
  planTypes: state.criteria.planTypes,
  codebooks: state.criteria.codebooks,
});

export default connect(mapStatetoProps)(StateDropDownBar);
